import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import soraImage from "@/assets/agent/kling@3x.webp";

export const KlingImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[soraImage]}
      {...props}
    />
  );
};

KlingImage.displayName = 'KlingImage';
